<template>
  <UtilityHeadline
    v-if="headline"
    :text="headline"
    :level="3"
    :class="{ 'dbc-text-color-primary': client !== 'cab' }"
  />

  <div>
    <FormKit
      type="form"
      :incomplete-message="false"
      :actions="false"
      :name="name"
      :id="name"
      @submit="submit"
      #default="{ state: { valid } }"
      form-class="dbc-formkit-form"
    >
      <div class="dbc-formkit-form-inner">
        <div>
          <slot name="left"></slot>
        </div>
        <div>
          <slot name="right"></slot>
        </div>
      </div>

      <UtilityText
        v-if="errorMessage"
        :text="errorMessage"
        class="dbc-u-error-txt"
      />

      <slot name="submit">
        <FormKit
          type="submit"
          :label="submitLabel"
          :prefix-icon="valid && !isLoading ? 'submitArrow' : ''"
          input-class="!min-w-[128px] !max-w-[160px]"
          :disabled="!valid || isLoading"
          :loading="isLoading"
        />
      </slot>
    </FormKit>
  </div>

  <UtilityText
    v-if="privacyStatement"
    :text="privacyStatementComp"
    class="dbc-form-privacy-statement"
  />
</template>

<script setup lang="ts">
interface Props {
  headline?: string
  submitLabel?: string
  isLoading: boolean
  privacyStatement?: string
  mandatoryFields?: string
  errorMessage?: string | null
  name?: string
}

const props = withDefaults(defineProps<Props>(), {
  submitLabel: 'submit',
  isLoading: false,
  errorMessage: null,
})

const { locale } = useI18n()

const client = useRuntimeConfig().public.client

const clientBaseUrlMapping = useRuntimeConfig().public
  .clientBaseUrlMapping as ClientBaseUrlMapping

const privacyStatementComp = computed(() => {
  const privacyPagePath = getPagePath['privacy']![locale.value]
  return props.privacyStatement?.replace(
    `(${privacyPagePath})`,
    `(${
      clientBaseUrlMapping[client as keyof ClientBaseUrlMapping]
    }${privacyPagePath})`
  )
})

const emit = defineEmits<{
  (e: 'submit', formData: FormDataBase): Promise<void>
}>()

function submit(formData: FormDataBase) {
  emit('submit', formData)
}
</script>
